export class Lock {
	constructor(public TableId: number, public RecordId: number) {

	}
}